import { Box, Flex, Grid, Image, ScrollArea, Skeleton, Text } from '@mantine/core';
import { FC, useEffect } from 'react';
import { useTrendingTodayStyles } from './styles';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/RoutesName';
import { DummyImage } from '../../assets';
import { useGetTrendingItems } from '../../services/trending-item/trending-item.service';

interface ITrendingTodayProps {
  setHasTrendingItems: React.Dispatch<React.SetStateAction<boolean>>;
}

const TrendingToday: FC<ITrendingTodayProps> = ({ setHasTrendingItems }) => {
  const { classes, cx } = useTrendingTodayStyles();
  const navigate = useNavigate();
  const { data, isLoading, isSuccess } = useGetTrendingItems();
  console.log(data);

  useEffect(() => {
    if (!!data) setHasTrendingItems(!!data?.length);
  }, [data?.length]);

  return (
    <>
      <Grid className={cx(classes.gridContainer)}>
        <Grid.Col className={cx(classes.gridCol, classes.trendingTodayGridCol)}>
          <Text fw={500} c='white'>
            TRENDING TODAY
          </Text>
        </Grid.Col>
        <Grid.Col className={cx(classes.gridCol, classes.sliderGridCol)}>
          <ScrollArea w={'100%'} type='never'>
            <Flex style={{ userSelect: 'none' }}>
              {isSuccess && data?.length
                ? data?.map((data, index) => (
                    <Flex
                      key={index}
                      direction='column'
                      justify='center'
                      align='center'
                      className={cx(classes.container)}
                      onClick={() => {
                        navigate(`${ROUTES.CATEGORY}/${data.name?.replace(/\s+/g, '')}`.toLocaleLowerCase(), {
                          state: { name: data.name },
                        });
                      }}>
                      <Box className={cx(classes.imageContainer)}>
                        <Image
                          withPlaceholder
                          fit='cover'
                          width={80}
                          height={80}
                          src={data.image_url ? data.image_url : DummyImage}
                          styles={(theme) => ({
                            image: {
                              borderRadius: 12,
                            },
                          })}
                        />
                      </Box>

                      <Box w={80}>
                        <Text ta='center' fw={500} fz={14} mt={4} lineClamp={1} lh={1}>
                          {data.name}
                        </Text>
                      </Box>
                    </Flex>
                  ))
                : null}
              {isLoading
                ? Array(2)
                    .fill(0)
                    .map((d, index) => (
                      <Flex
                        key={index}
                        direction='column'
                        justify='center'
                        align='center'
                        className={cx(classes.container)}>
                        <Skeleton h={80} w={80} mx='auto' />
                        <Skeleton h={20} w={80} mx='auto' mt={4} />
                      </Flex>
                    ))
                : null}
            </Flex>
          </ScrollArea>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default TrendingToday;
